module.exports = __webpack_public_path__ + "static/img/2-480.0d3d577d.jpg";